@if (backRouteLink) {
  <div class='mb-4'>
    <a mat-button color='accent' [routerLink]='backRouteLink' [queryParams]='backQueryParams'>
      <mat-icon>keyboard_arrow_left</mat-icon>
      <span>{{backTitle}}</span>
    </a>
  </div>
}
@if (datasetRS.record.value) {
  @if (datasetACS.datasetConfig.stepViewConfig) {
    @switch (datasetACS.datasetCode) {
      @case ("trip_packages") {
        @switch (datasetACS.getValueFromKeyPath("domainContext.domainTpl")) {
          @case (1) {
            <simp-temp-view-container
              [stepViewConfig]='stepViewConfig'
            ></simp-temp-view-container>
          }
          @default {
            <common-step-view-container
              [stepViewConfig]='datasetACS.datasetConfig.stepViewConfig'
            ></common-step-view-container>
          }
        }
      }
      @case ("products") {
        <simp-temp-view-container
          [stepViewConfig]='productStepViewConfig'
        ></simp-temp-view-container>
      }
      @default {
        <common-step-view-container
          [stepViewConfig]='datasetACS.datasetConfig.stepViewConfig'
        ></common-step-view-container>
      }
    }
  }
  @if (!datasetACS.datasetConfig.stepViewConfig) {
    @switch (datasetACS.datasetConfig.name) {
      @case ('actual_trips') {
        <actual-trip-detail></actual-trip-detail>
      }
      @case ('discount_rule_lists') {
        <discount-rule-list-detail></discount-rule-list-detail>
      }
      @case ('domains') {
        <domain-user></domain-user>
      }
      @case ('domain_packages') {
        <domain-packages></domain-packages>
      }
      @case ('plafond') {
        <plafond></plafond>
      }
      @case ('domain_user_roles') {
        <domain-user-role-permission-step></domain-user-role-permission-step>
      }
      @case ('sale_operations') {
        <pratica-detail></pratica-detail>
      }
      @case ('transmission_operations') {
        <transmission-data></transmission-data>
      }
      @default {
        @if (showTitle) {
          <h2>{{'DETAIL' | translate | titlecase}} {{datasetACS.datasetConfig.singleTitle | translate | titlecase}}</h2>
        }
        <div class="fx-row fx-justify-start fx-items-center fx-sm-column fx-xs-column">
          @if (datasetACS.actionConfig && datasetACS.actionConfig.viewConfig.formConfig) {
            <div class="card" card-data-viewer
              [showActions]='showActions'
              [record]='datasetRS.record.value'
              [datasetACS]='datasetACS'
              [viewFormConfig]='datasetACS.actionConfig.viewConfig.formConfig'
              [editFormConfig]='$safeNavigationMigration(datasetACS.datasetConfig.defaultActions?.edit?.viewConfig?.formConfig)'
            ></div>
          }
        </div>
        @if (!datasetACS.actionConfig || !datasetACS.actionConfig.viewConfig.formConfig) {
          <p>TODO</p>
          <pre>{{inputRecord | json}}</pre>
        }
      }
    }
  }
}